<template>
  <div class="section">
    <h3 class="section-title">Felhasználói fiók szerkesztése</h3>
    <div class="section-content">
      <b-alert
        variant="success"
        :show="message.length > 0"
      >
        {{ message }}
      </b-alert>
      <b-form-group
        :state="nameState && errors$name.length < 1"
        :invalid-feedback="errors$name"
      >
        <label for="name">Név</label>
        <b-form-input
          id="name"
          v-model="name"
          :state="nameState && errors$name.length < 1"
          type="text"
          placeholder="A felhasználó neve"
          required
        />
      </b-form-group>
      <b-form-group
        :state="emailState && errors$email.length < 1"
        :invalid-feedback="errors$email"
      >
        <label for="email">Email</label>
        <b-form-input
          id="email"
          v-model="email"
          :state="emailState && errors$email.length < 1"
          type="email"
          placeholder="A felhasználó email címe"
          required
        />
      </b-form-group>
      <b-form-group
        :state="passwordState && errors$password.length < 1"
        :invalid-feedback="errors$password"
      >
        <div class="row">
          <div class="col-sm-6">
            <label for="password">Jelszó</label>
            <b-form-input
              id="password"
              v-model="password"
              :state="passwordState && errors$password.length < 1"
              type="password"
              autocomplete="new-password"
              placeholder="Az új jelszó"
            />
          </div>
          <div class="col-sm-6">
            <label for="confirm">Jelszó ismét</label>
            <b-form-input
              id="confirm"
              v-model="confirmPassword"
              :state="passwordState && errors$password.length < 1"
              type="password"
              autocomplete="false"
              placeholder="Az új jelszó ismét"
            />
          </div>
        </div>
      </b-form-group>
      <b-form-group
        :state="errors$lang.length < 1"
        :invalid-feedback="errors$lang"
      >
        <label for="name">Nyelv</label>
        <b-form-select
          v-model="lang"
          :state="errors$lang.length < 1"
          :options="$store.state.userLangs"
        />
      </b-form-group>
      <div class="section-divider" />
      <b-form-group
        class="text-right mt-2 pt-3"
      >
        <b-button
          :disabled="saving || !validUser"
          variant="success"
          @click="save"
        >
          <span>Mentés</span>
          <b-spinner
            v-show="saving"
            variant="light"
            label="Mentés"
            small
          />
        </b-button>
      </b-form-group>
    </div>
  </div>
</template>
<script>
import ErrorHandler from '../../utils/mixins/ErrorHandler'
import FormValidation from '../../utils/mixins/FormValidation'

export default {
  mixins: [
    FormValidation(['password', 'email', 'name', 'lang']),
    ErrorHandler()
  ],
  props: {
    user: {
      required: true,
      type: Object,
      default() {
        return {
          id: -1,
          name: '',
          email: '',
          lang: 'hu',
        }
      }
    },
  },
  data() {
    return {
      id: -1,
      name: '',
      email: '',
      lang: 'hu',
      password: '',
      confirmPassword: '',
      saving: false,
      message: ''
    }
  },
  computed: {
    emailState: function() {
      return this.validateEmail(this.email)
    },
    nameState: function() {
      return this.name.length > 0
    },
    passwordState: function() {
      if(this.password.length < 1) {
        return
      }

      return this.password === this.confirmPassword && this.password.length > 7
    },
    validUser: function() {
      return this.emailState && this.nameState && this.passwordState !== false
    }
  },
  watch: {
    password: function(password) {
      this.checkPassword(password, this.confirmPassword)
    },
    confirmPassword: function(confirm) {
      this.checkPassword(this.password, confirm)
    }
  },
  mounted() {
    _.forEach(this.user, (value, name) => {
      this[name] = value
    })
  },
  methods: {
    checkPassword: function(password, confirm) {
      this.errors$password = ''

      if(password !== confirm) {
        this.errors$password = 'A jelszavak nem egyeznek meg'
      }

      if(password.length < 7) {
        this.errors$password = 'A jelszó legalább 8 karakter hosszú legyen'
      }
    },
    save() {
        if(!this.validUser) {
          return
        }

        this.clearErrors()
        this.saving = true
        this.message = ''

        this.$http.post(this.$url('profile.user.update'), {
          id: this.id,
          name: this.name,
          email: this.email,
          lang: this.lang,
          password: this.password
        })
          .then(({data}) => {
            if(data.user) {

              if(data.reload === true) {
                window.location = this.$url('profile.user.show')
              }

              this.message = 'Sikeres mentés'
            } else {
              this.handleError('Hiba történt a mentés közben')
            }
          })
          .catch(this.handleErrors)
          .finally(() => {
            this.saving = false
          })
      },
  }
}
</script>